import { Event, Voucher } from 'inscreva-sse-models';

import { Form } from './form';

export class Person {
  nome: string;

  email: string;

  cpf?: string;
}

export class Subscription {
  person: Person;

  [field: string]: any;

  private constructor(vouchers: Array<Voucher>) {
    this.vouchers = vouchers;
  }

  static fromEvent(event: Event): Subscription {
    const subscription = Form.buildFormData(event, { mode: 'object' });
    const vouchers = Event.generateVouchers(event);

    return { ...subscription, ...new Subscription(vouchers) } as Subscription;
  }

  static fromJson(json: any): Subscription {
    return json && Object.assign(new Subscription(json.vouchers || []), json);
  }
}
